module.exports = __webpack_public_path__ + "img/NextGenWebInterface.755e3569.png";